import Vue from "vue";
import Vuex from "vuex";

import {API_FINISH_LOADING, API_START_LOADING, APP_VERSION_GESEHEN, UPDATE_VERFUEGBAR} from "./mutations.type";

import session from "./session";
import tickets from "./tickets";
import beschwerden from "./beschwerden";
import kategorien from "./kategorien";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiLoading: 0,
    // Plugin-Versionen aus dem Header X-RVE-Version der ersten API-Antwort in diesem Tab
    appVersion: null,
    updateVerfuegbar: false,
  },
  mutations: {
    [API_START_LOADING](state) {
      state.apiLoading++;
    },
    [API_FINISH_LOADING](state) {
      state.apiLoading--;
    },
    [APP_VERSION_GESEHEN](state, version) {
      // Antworten ohne Header (z. B. während ein Plugin neu geladen wird) zählen nicht
      if (!version) return;
      if (state.appVersion == null) state.appVersion = version;
      else if (version !== state.appVersion) state.updateVerfuegbar = true;
    },
    [UPDATE_VERFUEGBAR](state) {
      state.updateVerfuegbar = true;
    },
  },
  actions: {},
  modules: {
    session,
    tickets,
    beschwerden,
    kategorien
  },
  getters: {
    apiIsLoading: (state) => state.apiLoading > 0,
  }
});
